// src/app/slices/uvcSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { IUvc, IUvcParams, AccessoryState } from '../models';

const initialState: AccessoryState<IUvc, IUvcParams> = {
  accessories: {},
  params: null,
};
const uvcSlice = createSlice({
  name: 'uvc',
  initialState,
  reducers: {
    setUvc: (state, action: PayloadAction<IUvc>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setUvcParams: (state, action: PayloadAction<IUvcParams>) => {
      state.params = action.payload;
    },
    deleteUvc: deleteAccessory,
  },
});

export const { setUvc, setUvcParams, deleteUvc } = uvcSlice.actions;

export default uvcSlice.reducer;
